


















































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import ModerationDistributionsFilter from "@/components/UserManagement/ModerationDistributions/ModerationDistributionsFilter.vue";
import { BulkDistrItem } from '@/store/user_management/distr_moderation/types';
import { DateTime } from 'luxon';

function date(value: string) {
  if (!value) return;
  else return DateTime.fromISO(value).toFormat('dd.LL.yyyy HH:mm:ss');
}

@Component({ components: {ModerationDistributionsFilter, ScrollButton}, filters: {date}})
export default class ModerationDistributions extends BaseItemsPage<BulkDistrItem>{

  @Getter("bulkDistrList") distributionsResponse: any;

  private is_show_filter = false;
  currentSort = "id";
  currentSortOrder = "desc";
  tableFields = ['id', 'create_date', 'partner', 'transport', 'recipients_count'];

  getData(): any {
    return this.distributionsResponse;
  }
}
